import breakpoints from '../../theme/breakpoints'
import theme from '../../theme/news12'

import css from 'styled-jsx/css'

export default css.global`
  .block, .list {
    font-size: 1em;
    font-weight: 300;
    line-height: 1.5em;
    margin: 18px 0 30px 0;
  }

  .static-page-container {
    box-sizing: border-box;
    width: 100%;
    max-width: 800px;
    margin: 0 auto;  
    padding: 24px;
  }
  
  .static-page-container h1 {
    margin-bottom: 36px;
  } 

  .static-page-container a {
    word-wrap: break-word;
  }
  
  .static-page-container blockquote {
    margin: 0 0 36px 0;
    padding: 5px 0px 5px 40px;
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  
  .static-page-container blockquote:before {
    content: "";
    height: 100%;
    width: 24px;
    background: #E3E500;
    position: absolute;
    left: 0;
  }
  
  .static-page-container blockquote > p {
    font-weight: 500;
    font-size: 28px;
    line-height: 38px;
    color: ${theme.colors.codGray};
    margin: 0;
  }
  
  .static-page-container p, .block, .block i {
    font-weight: 300;
    margin: 18px 0;
  }
  
  .static-page-container div.embed {
    margin: 0 auto 30px auto;
    max-width: 100%;
  }
  
  .facebook-embed {
    overflow: hidden;
    text-align: center;
  }
  
  .static-page-container .twitter-tweet {
    margin-left: auto;
    margin-right: auto;
  }
  .static-page-container .twitter-tweet:before {
    background: transparent;
    width: 0;
  }
  
  .block, .list {
    font-size: 1em;
    font-weight: 300;
    line-height: 1.5em;
  }
  
  .list li {
    font-weight: 300;
    margin: 18px 0 30px 0;
  }
  
  div.embed {
    margin: 0 auto 30px auto;
    max-width: 100%;
  }
  
  .caption, .image em {
    display: block;
    font-weight: 400;
    font-size: 16px;
    text-align: center;
    margin: 10px 0 18px 0;
  }
  
  .body-video {
    margin-bottom: 18px;
  }
  
  @media only screen and (min-width: ${breakpoints.lg}px) {
    .main-layout-container {
      width: fit-content;
      margin: 0 auto;
      padding-top: 24px; 
    }

    .main-layout {
      display: inline-block;
      width: 728px;
      background-color: ${theme.colors.white};
    }
    
    .main-layout-sidebar {
      display: inline-block;
      vertical-align: top;
      top: 120px;
    }
  }
`
export const hideLayout = css.global`
  .redesigned-navigation, .main-footer {
    display: none !important;
  }
`
